import rawRegistry from '@/lib/control-registry.json';

export type ControlRegistryEntry = {
  control_key: string;
  group: string;
  title: string;
  short_description: string;
  next_action_template: string;
  status_levels: string[];
  deprecated?: boolean;
};

export const CONTROL_REGISTRY = rawRegistry as ControlRegistryEntry[];

export const CONTROL_ALIASES: Record<string, string> = {
  geo_policy_detect: 'admin_geo_guard',
  a01_xmlrpc_enabled: 'a01_xmlrpc',
  a01_privilege_escalation_detection: 'a01_privilege_escalation',
  a01_admin_count_baseline: 'a01_admin_capabilities',
  a07_failed_login_burst: 'a07_bruteforce_signals',
  mfa_coverage: 'mfa_coverage_snapshot',
  privilege_escalation: 'a01_privilege_escalation',
};

export const KNOWN_CONTROL_KEYS = new Set(CONTROL_REGISTRY.map((entry) => entry.control_key));

export const resolveControlKey = (key: string) => CONTROL_ALIASES[key] ?? key;

export const isKnownControlKey = (key: string) => KNOWN_CONTROL_KEYS.has(resolveControlKey(key));

export const getControlRegistryEntry = (key: string) =>
  CONTROL_REGISTRY.find((entry) => entry.control_key === resolveControlKey(key));
